import { t } from "i18next";
import * as z from "zod";

import { AGENT_TYPES } from "@/features/shared/api/enums";

/**
 * Schéma du formulaire d'enrôlement d'un agent (`POST /Agents/add`).
 *
 * Factory (règle projet) : créé via `createAgentSchema()` et mémoïsé au
 * niveau composant sur la langue courante — jamais d'instance exportée.
 * Requis : keycloakUserId, fullName, agencyCode ; agentType vaut BOTH par
 * défaut côté serveur ; floatWalletId est une réf. logique
 * wallet-service (uuid) optionnelle.
 */
export const createAgentSchema = () =>
  z.object({
    keycloakUserId: z.string().trim().min(1, { message: t("requiredFieldError") }),
    fullName: z.string().trim().min(1, { message: t("requiredFieldError") }),
    agencyCode: z.string().trim().min(1, { message: t("requiredFieldError") }),
    zone: z.string().trim().or(z.literal("")),
    agentType: z.enum(AGENT_TYPES, {
      errorMap: () => ({ message: t("requiredFieldError") }),
    }),
    floatWalletId: z
      .string()
      .trim()
      .uuid({ message: t("invalidFieldError") })
      .or(z.literal("")),
  });

export type AgentFormValues = z.infer<ReturnType<typeof createAgentSchema>>;
